import { request } from '@umijs/max';

// 获取收件人列表
export async function getUserAddressPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/admin/userAddress/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
      with: ['user'],
    },
  });
}

// 获取全部收件人
export async function getUserAddressAll({
  filter,
}: {
  filter: API.FormValues;
}) {
  return request('/api/admin/userAddress/all', {
    method: 'POST',
    data: {
      filter,
    },
  });
}

// 获取收件人详情
export async function getUserAddressInfo(values: API.FormValues) {
  return request('/api/admin/userAddress/info', {
    method: 'POST',
    data: values,
  });
}

// 创建收件人
export async function addUserAddress(values: API.FormValues) {
  return request('/api/admin/userAddress/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑收件人
export async function editUserAddress(values: API.FormValues) {
  return request('/api/admin/userAddress/edit', {
    method: 'POST',
    data: values,
  });
}

// 删除收件人
export async function removeUserAddress(values: API.FormValues) {
  return request('/api/admin/userAddress/remove', {
    method: 'POST',
    data: values,
  });
}
